import type { HttpClient, RequestOptions } from '../client.js';
import {
  type EnsResolveData,
  type EnsReverseData,
  resolveEnsParamsSchema,
  reverseEnsParamsSchema,
} from '@spectrum-nodes/api-spec/models';
import { parseParams } from '../internals/validation.js';

/** ENS name resolution */
export class EnsNamespace {
  constructor(private readonly client: HttpClient) {}

  /** Resolve an ENS name to an address. */
  async resolve(name: string, options?: RequestOptions): Promise<EnsResolveData> {
    const validated = parseParams(resolveEnsParamsSchema, { name });
    return this.client.jsonRpc<EnsResolveData>('resolveENS', validated, options);
  }

  /** Reverse lookup — get ENS name for an address. */
  async reverse(address: string, options?: RequestOptions): Promise<EnsReverseData> {
    const validated = parseParams(reverseEnsParamsSchema, { address });
    return this.client.jsonRpc<EnsReverseData>('reverseENS', validated, options);
  }
}
